import { createEvent } from '@cobuildlab/react-simple-state';
import { PlaceResponseType } from '../../shared/types';

export const OnFetchGeoData = createEvent<PlaceResponseType[]>();
export const OnFetchGeoDataError = createEvent<TypeError>();
